export const campaignIdsWithExpirationDate: number[] = [654432, 654431, 654430, 654428];

export const superiorIdsWithExpirationDate: number[] = [];
